import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { EncryptionService } from '../encryption/encryption.service';
import { environment } from '../../../../environments/environment';
import { LoginService } from 'app/services/login/login.service';
import { CVA_CONSTANTS } from 'app/util/constants';

@Injectable({
  providedIn: 'root'
})
export class ResponseInterceptorService implements HttpInterceptor {

  constructor(
    private encryptionService: EncryptionService,
    private loginService: LoginService,
  ) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Logic to parse responses (Eg: redirect to login if error code is 401)
    return next.handle(request).pipe(
      tap({
        next: async (event: HttpEvent<unknown>) => {
          if (event instanceof HttpResponse) {
            // If the response body is a string, decrypt it
            if (event.url?.includes(environment.cva_url)) {
              const decryptedBody = await this.encryptionService.decryptAllTextFields(event.body);
              return event.clone({ body: decryptedBody });
            }
          }
          return event;
        },
        // eslint-disable-next-line  @typescript-eslint/no-explicit-any
        error: (error: any) => {
          if ([401].indexOf(error.status) !== -1 || (error && error.error &&
            ([401].indexOf(error.error.code) !== -1))) {
            if (this.loginService.loggedIn$.value) {
              this.loginService.logout();
              const message = CVA_CONSTANTS.MESSAGE.INACTIVE_ACCOUNT;
              error.error = { errorMessage: message, message };
            } else {
              localStorage.clear();
            }
          }
          return error;
        }
      }));
  }
}
